import React from 'react';
import Formsy from 'formsy-react';
import CreditCardInput from 'react-credit-card-input';
import FormsyInput from '../../form/FormsyInput';
import SimpleInput from '../../form/SimpleInput';
import Checkbox from '../../form/Checkbox';
import Select from '../../form/Select';
import { maskPhone } from '../../../masks';
import { isEmptyObj } from '../../../helpers/util';

/*
// Notes: Price Calculation.
- Service fee is always $250. Does not change based on size.
- Travel is always $15.
- Tax is only calculated on service fee (not groceries or travel)
- Grocery costs should have 3 tiers, one for each size:
- Estimated cost for small household: $80-$100
- Estimated cost for medium household: $110-$150
- Estimated cost for large household: $130-$160
*/
const Pricing = {
  serviceFee: 250,
  groceryEstimate: {
    small: 80,
    medium: 110,
    large: 130
  },
  buffer: {
    small: 20,
    medium: 40,
    large: 30
  },
  travel: 15,
  taxRate: 0.08875
};

class ClientDetails extends React.Component {
  defaultState = {
    first_name: '', // first_name
    last_name: '', // last_name
    email: '', // email
    password: '', // password
    password_confirmation: '', // password_confirmation
    phone_number: '', // phone_number
    refer: '',

    street_address: '', // service_addresses[0].street_address
    street_address_continued: '', // service_addresses[0].street_address_continued
    city: '', // service_addresses[0].city
    state: '', // service_addresses[0].state
    zip_code: '', // service_addresses[0].zip

    cc_number: '',
    expiration_date: '',
    code: '',

    promo_code: '',
    showCode: false,

    useBillingAddress: false,
    billing_address: '',
    billing_city: '',
    billing_state: '',
    billing_zip_code: ''
  };

  state = {
    ...this.defaultState
  };

  referOptions = [
    { value: 'google', label: 'Google Search' },
    { value: 'word_of_mouth', label: 'Word of Mouth' },
    { value: 'event', label: 'Culinistas Event' },
    { value: 'article', label: 'Article / Publication' },
    { value: 'social', label: 'Social Media' }
  ];

  render() {
    const validationErrors = {
      isEmail: 'Invalid Email',
      equalsField: 'Password must match.'
    };

    const EstimatedPrice = {
      groceries:
        '$' +
        Pricing.groceryEstimate[this.props.client.portion_size] +
        ' - $' +
        // eslint-disable-next-line
        parseInt(
          Pricing.groceryEstimate[this.props.client.portion_size] +
            Pricing.buffer[this.props.client.portion_size]
        ),
      tax: (Pricing.serviceFee * Pricing.taxRate).toFixed(2)
    };
    const EstimatedTotalLow =
      parseFloat(Pricing.serviceFee) +
      parseFloat(Pricing.groceryEstimate[this.props.client.portion_size]) +
      parseFloat(Pricing.travel) +
      // eslint-disable-next-line
      parseInt(EstimatedPrice.tax); // + parseFloat(EstimatedPrice.tax);
    const EstimatedTotalHigh =
      EstimatedTotalLow + Pricing.buffer[this.props.client.portion_size];

    return (
      <div className="on-boarding__step on-boarding_step--client">
        <div className="on-boarding__wrap on-boarding__wrap--client-details">
          <h1 className="on-boarding__h1">
            Just a little housekeeping so we can send you a chef.
          </h1>
          <Formsy
            onValidSubmit={this.handleSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
            onValid={this.handleValid}
            onInvalid={this.handleInvalid}
          >
            <div className="on-boarding__form-group on-boarding__form-group--no-pad">
              <h3 className="on-boarding__h3">Your Information</h3>

              <div className="form__row">
                <div className="form__row-item form__row-item--half">
                  <FormsyInput
                    type="text"
                    name="first_name"
                    placeholder="First Name"
                    value={this.state.first_name}
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div className="form__row-item form__row-item--half">
                  <FormsyInput
                    type="text"
                    name="last_name"
                    placeholder="Last Name"
                    value={this.state.last_name}
                    onChange={this.handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form__row">
                <div className="form__row-item form__row-item--full">
                  <FormsyInput
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    validations={'isEmail'}
                    validationErrors={validationErrors}
                    required
                  />
                </div>
              </div>

              <div className="form__row form__row--align-top">
                <div className="form__row-item form__row-item--half">
                  <FormsyInput
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={this.state.password}
                    onChange={this.handleChange}
                    required
                  />
                  <p className="p--green-text small">
                    Requires: 1 uppercase, 1 lowercase and 1 number
                  </p>
                </div>
                <div className="form__row-item form__row-item--half">
                  <FormsyInput
                    type="password"
                    name="password_confirmation"
                    placeholder="Confirm Password"
                    value={this.state.password_confirmation}
                    onChange={this.handleChange}
                    validations={'equalsField:password'}
                    validationErrors={validationErrors}
                    required
                  />
                </div>
              </div>

              <div className="form__row">
                <div className="form__row-item form__row-item--full">
                  <FormsyInput
                    type="tel"
                    name="phone_number"
                    placeholder="Phone"
                    value={this.state.phone_number}
                    onChange={this.handleChange}
                    mask={maskPhone}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="on-boarding__form-group">
              <h3 className="on-boarding__h3">
                How did you hear about The Culinistas?
              </h3>
              <div className="form__row">
                <div className="form__row-item form__row-item--half">
                  <Select
                    name="refer"
                    placeholder="Select One"
                    value={this.state.refer}
                    options={this.referOptions}
                    onChange={val => this.handleSelectChange('refer', val)}
                  />
                </div>
              </div>
            </div>

            <div className="on-boarding__form-group">
              <h3 className="on-boarding__h3">Service Address</h3>
              <div className="form__row">
                <div className="form__row-item form__row-item--half">
                  <FormsyInput
                    type="text"
                    name="street_address"
                    placeholder="Address 1"
                    value={this.state.street_address}
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div className="form__row-item form__row-item--half">
                  <FormsyInput
                    type="text"
                    name="street_address_continued"
                    placeholder="Address 2 (Optional) "
                    value={this.state.street_address_continued}
                    onChange={this.handleChange}
                  />
                </div>
              </div>

              <div className="form__row">
                <div className="form__row-item form__row-item--full">
                  <FormsyInput
                    type="text"
                    name="city"
                    placeholder="City"
                    value={this.state.city}
                    onChange={this.handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form__row">
                <div className="form__row-item form__row-item--half">
                  <FormsyInput
                    type="text"
                    name="state"
                    placeholder="State"
                    value={this.state.state}
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <div className="form__row-item form__row-item--half">
                  <FormsyInput
                    type="text"
                    name="zip_code"
                    placeholder="Zip Code"
                    value={this.state.zip_code}
                    onChange={this.handleChange}
                    required
                  />
                </div>
              </div>

              <Checkbox
                className="checkbox--small checkbox--word-wrap"
                name="showBillingAddress"
                value={this.state.useBillingAddress}
                placeholder="Billing Address is different than Service Address"
                onChange={this.toggleBilling}
              />
            </div>

            {this.state.useBillingAddress && (
              <div className="on-boarding__form-group">
                <h3 className="on-boarding__h3">Billing Address</h3>
                <div className="form__row">
                  <div className="form__row-item form__row-item--full">
                    <FormsyInput
                      type="text"
                      name="billing_address"
                      placeholder="Address"
                      value={this.state.billing_address}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form__row">
                  <div className="form__row-item form__row-item--full">
                    <FormsyInput
                      type="text"
                      name="billing_city"
                      placeholder="City"
                      value={this.state.billing_city}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form__row">
                  <div className="form__row-item form__row-item--half">
                    <FormsyInput
                      type="text"
                      name="billing_state"
                      placeholder="State"
                      value={this.state.billing_state}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  <div className="form__row-item form__row-item--half">
                    <FormsyInput
                      type="text"
                      name="billing_zip_code"
                      placeholder="Zip Code"
                      value={this.state.billing_zip_code}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="on-boarding__form-group">
              <h3 className="on-boarding__h3">Billing Information</h3>

              <div className="form__row">
                <div className="form__row-item form__row-item--full">
                  <CreditCardInput
                    cardNumberInputProps={{
                      value: this.state.cc_number,
                      name: 'cc_number',
                      onChange: this.handleChange
                    }}
                    cardExpiryInputProps={{
                      value: this.state.expiration_date,
                      name: 'expiration_date',
                      onChange: this.handleChange
                    }}
                    cardCVCInputProps={{
                      value: this.state.code,
                      name: 'code',
                      onChange: this.handleChange
                    }}
                    dangerTextClassName="cc-input--invalid"
                    fieldClassName="cc-input cc-input--onboarding"
                  />

                  <SimpleInput
                    type="hidden"
                    name="cc_number"
                    value={this.state.cc_number}
                    required
                  />
                  <SimpleInput
                    type="hidden"
                    name="expiration_date"
                    value={this.state.expiration_date}
                    required
                  />
                  <SimpleInput
                    type="hidden"
                    name="code"
                    value={this.state.code}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="on-boarding__form-group">
              <h3 className="on-boarding__h3">Estimated Price</h3>
              <div className="on-boarding-est">
                <div className="on-boarding-est__row">
                  <div className="on-boarding-est__col">Service Fee</div>
                  <div className="on-boarding-est__col on-boarding-est__col--right">
                    ${Pricing.serviceFee}
                  </div>
                </div>
                <div className="on-boarding-est__row">
                  <div className="on-boarding-est__col">Grocery Estimate</div>
                  <div className="on-boarding-est__col on-boarding-est__col--right">
                    {EstimatedPrice.groceries}
                  </div>
                </div>
                <div className="on-boarding-est__row">
                  <div className="on-boarding-est__col on-boarding-est__col--small">
                    Your grocery will be a little higher to prepare you for your
                    first service.
                  </div>
                </div>
                <div className="on-boarding-est__row">
                  <div className="on-boarding-est__col">Travel</div>
                  <div className="on-boarding-est__col on-boarding-est__col--right">
                    ${Pricing.travel}
                  </div>
                </div>
                <div className="on-boarding-est__row">
                  <div className="on-boarding-est__col">Tax</div>
                  <div className="on-boarding-est__col on-boarding-est__col--right">
                    ${EstimatedPrice.tax}
                  </div>
                </div>
                <div className="on-boarding-est__row">
                  {!this.state.promo_code && !this.state.showCode && (
                    <div className="on-boarding-est__col">
                      <div className="a--blue" onClick={this.showCode}>
                        + Add Code
                      </div>
                    </div>
                  )}
                  {this.state.promo_code && !this.state.showCode && (
                    <div className="on-boarding-est__col">
                      <p>
                        <b>Code:</b> {this.state.promo_code}
                      </p>
                      <div className="a--blue" onClick={this.showCode}>
                        + Edit Code
                      </div>
                    </div>
                  )}
                  {this.state.showCode && (
                    <div className="on-boarding-est__promo">
                      <div className="on-boarding-est__col">
                        <p className="simple-input__label">Code</p>
                        <SimpleInput
                          type="text"
                          name="promo_code"
                          placeholder="Promo Code"
                          value={this.state.promo_code}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="on-boarding-est__col on-boarding-est__col--small">
                        <p>
                          The code will be reflected in your bill after your
                          service is complete.
                        </p>
                      </div>
                      <span className="a--blue" onClick={this.saveCode}>
                        Save{' '}
                      </span>
                      <span className="a--blue" onClick={this.hideCode}>
                        Cancel
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className="on-boarding-est on-boarding-est--total">
                <div className="on-boarding-est__row">
                  <div className="on-boarding-est__col">
                    <h3 className="on-boarding__h3">Estimated Total</h3>
                  </div>
                  <div className="on-boarding-est__col on-boarding-est__col--total">
                    ${EstimatedTotalLow} - ${EstimatedTotalHigh}
                  </div>
                </div>
                <div className="on-boarding-est__row">
                  <div className="on-boarding-est__col on-boarding-est__col--small">
                    <p>
                      The final total will be charged to you after each weekly
                      service is completed.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <SimpleInput
              type="hidden"
              name="all_forms_valid"
              value={this.props.actions.isValid('submit')}
              validations="isTrue"
            />
            <input
              ref={this.props.actions.assignTrigger}
              type="submit"
              hidden
            />
          </Formsy>
        </div>
      </div>
    );
  }

  toggleBilling = () =>
    this.setState({ useBillingAddress: !this.state.useBillingAddress });

  showCode = () => this.setState({ showCode: true });

  saveCode = () => this.setState({ showCode: false });

  hideCode = () => this.setState({ showCode: false, promo_code: '' });

  handleChange = e =>
    this.setState({
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value
    });

  handleSelectChange = (name, value = null) => this.setState({ [name]: value });

  handleInvalidSubmit = () => console.log('failed submit');

  handleValid = () => this.props.actions.setValidState('main', true);
  handleInvalid = () => this.props.actions.setValidState('main', false);

  // this will be triggered from the ChefOnboarding component
  handleSubmit = (formData, data, errors) => {
    const {
      first_name,
      last_name,
      email,
      password,
      password_confirmation,
      phone_number,
      street_address,
      street_address_continued,
      city,
      state,
      zip_code,
      promo_code,
      refer,
      cc_number,
      expiration_date,
      code,
      billing_address,
      billing_city,
      billing_state,
      billing_zip_code
    } = this.state;

    const updatedClient = {
      first_name,
      last_name,
      email,
      password,
      password_confirmation,
      phone_number,
      code: promo_code, // WS double named this variable. :)
      refer,
      service_addresses: [
        {
          street_address,
          street_address_continued,
          city,
          state,
          zip_code
        }
      ],
      payment: {
        cc_number, //: "4111111111111111",
        expiration_date, //: "2020-05",
        code, //: "111",

        address: this.state.useBillingAddress
          ? billing_address
          : street_address + street_address_continued,
        city: this.state.useBillingAddress ? billing_city : city,
        state: this.state.useBillingAddress ? billing_state : state,
        zip_code: this.state.useBillingAddress ? billing_zip_code : zip_code
      }
    };

    this.props.updateClient(updatedClient, this.props.postSignup);
  };

  reset = () => {
    this.props.updateClient({ ...this.defaultState });
  };

  initState(prevProps = {}) {
    const state = {};
    const { client: prevClient } = prevProps;
    const { client = {} } = this.props;

    if (!prevClient) {
      state.first_name = client.first_name || '';
      state.last_name = client.last_name || '';
      state.email = client.email || '';
      state.password = client.password || '';
      state.password_confirmation = client.password_confirmation || '';
      state.phone_number = client.phone_number || '';
      state.promo_code = client.promo_code || '';

      const { service_addresses = [] } = client;
      if (service_addresses.length > 0) {
        state.street_address =
          'street_address' in service_addresses[0]
            ? service_addresses[0].street_address
            : '';
        state.street_address_continued =
          'street_address_continued' in service_addresses[0]
            ? service_addresses[0].street_address_continued
            : '';
        state.city =
          'city' in service_addresses[0] ? service_addresses[0].city : '';
        state.state =
          'state' in service_addresses[0] ? service_addresses[0].state : '';
        state.zip_code =
          'zip_code' in service_addresses[0]
            ? service_addresses[0].zip_code
            : '';
      }

      if (client.payment) {
        state.billing_address =
          'address' in client.payment ? client.payment.address : '';
        state.billing_city =
          'address' in client.payment ? client.payment.city : '';
        state.billing_state =
          'address' in client.payment ? client.payment.state : '';
        state.billing_zip_code =
          'address' in client.payment ? client.payment.zip_code : '';
      }
    }
    // this may not be needed?
    // else {
    //   console.log('new', state);
    //
    //   // check individual
    //   if(client.first_name !== prevClient.first_name)
    //     state.first_name = client.first_name || '';
    //   if(client.last_name !== prevClient.last_name)
    //     state.last_name = client.last_name || '';
    //   if(client.email !== prevClient.email)
    //     state.email = client.email || '';
    //   if(client.password !== prevClient.password)
    //     state.password = client.password || '';
    //   if(client.password_confirmation !== prevClient.password_confirmation)
    //     state.password_confirmation = client.password_confirmation || '';
    //   if(client.phone_number !== prevClient.phone_number)
    //     state.phone_number = client.phone_number || '';
    //
    //   const {service_addresses=[]} = client;
    //   if(
    //     service_addresses !== prevClient.service_addresses
    //     && service_addresses.length > 0
    //   ){
    //     state.street_address = 'street_address' in service_addresses[0] ? service_addresses[0].street_address : '';
    //     state.street_address_continued = 'street_address_continued' in service_addresses[0] ? service_addresses[0].street_address_continued : '';
    //     state.city = 'city' in service_addresses[0] ? service_addresses[0].city : '';
    //     state.state = 'state' in service_addresses[0] ? service_addresses[0].state : '';
    //     state.zip_code = 'zip_code' in service_addresses[0] ? service_addresses[0].zip_code : '';
    //   }
    // }

    if (!isEmptyObj(state))
      this.setState(state /*, console.log('initState', state)*/);
  }

  componentWillMount() {
    // handle resets here
    const reset = this.props.resets.includes(this.props.step);
    if (reset) this.reset();
    else this.initState();
  }

  componentDidUpdate(prevProps, nextState) {
    this.initState(prevProps);
  }
}

export default ClientDetails;



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientDetails.js